import { IForm } from '@/components/types'
export const modalConfig: IForm = {
  formItems: [
    {
      field: 'type',
      type: 'select',
      label: '标签',
      placeholder: '请选择标签',
      options: [
        { title: '未成交', value: '0' },
        { title: '全款', value: '1' },
        { title: '518', value: '2' },
        { title: '同行', value: '3' },
        { title: '成交', value: '4' },
        { title: '新客户', value: '6' }
      ],
      rules: { required: true, message: '标签必传的', trigger: 'blur' }
    },
    {
      field: 'transactionTime',
      type: 'datepicker',
      label: '成交时间',
      otherOptions: {
        placeholder: '选择成交时间',
        type: 'datetime',
        'value-format': 'YYYY-MM-DD HH:mm:ss'
      }
    },
    {
      field: 'dealEmpId',
      type: 'select',
      label: '成交员工',
      clearable: true,
      filterable: true,
      placeholder: '请选择成交员工'
    }
  ],
  colLayout: 24,
  itemStyle: {}
}
